export type ChannelsSkeletonKind = 'matrix' | 'detail';

/**
 * The agent's Channels module (`AppRouter.tsx`, under `:AssistantID`):
 * `/accounts/:accountId/assistants/:AssistantID/channels` is the matrix and
 * `…/channels/:channelId` one channel's detail. Anchored at both ends, so
 * nothing nested deeper matches. `/assistants/new/channels` is the legacy
 * creation flow (`ChannelsStep`), a different screen: `new` is never an agent id
 * here.
 */
const CHANNELS_ROUTE = /^\/accounts\/[^/]+\/assistants\/(?!new\/)[^/]+\/channels(?:\/([^/]+))?\/?$/;

/** Which channels shape `pathname` loads into, or `null` when it isn't one of them. */
export function channelsSkeletonKind(pathname: string): ChannelsSkeletonKind | null {
  const match = CHANNELS_ROUTE.exec(pathname);
  if (!match) return null;
  return match[1] ? 'detail' : 'matrix';
}
